import { render, staticRenderFns } from "./HelpCategories.vue?vue&type=template&id=50700681&"
import script from "./HelpCategories.vue?vue&type=script&lang=js&"
export * from "./HelpCategories.vue?vue&type=script&lang=js&"
import style0 from "./HelpCategories.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50700681')) {
      api.createRecord('50700681', component.options)
    } else {
      api.reload('50700681', component.options)
    }
    module.hot.accept("./HelpCategories.vue?vue&type=template&id=50700681&", function () {
      api.rerender('50700681', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/HelpCategories.vue"
export default component.exports